import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';

import Avatar from '../../../components/avatar/avatar';
import sanitizeHtml from '../../../utils/sanitizeHtmlUtil';

export class BroadcastMessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t, message } = this.props;
    if (!message) return null;
    return (
      <article className="br-card br-broadcast-message">
        <h2>{message.title}</h2>
        <div className="br-broadcast-message__recipients">
          <span>{t('MessageTo')}:</span>
          {
            (message.recipients || []).map((recipient, index) => (
              <Avatar
                key={recipient._id}
                diameter={25}
                user={recipient}
                name={recipient.displayName}
                style={{ marginLeft: index > 0 ? -2 : 0 }}
              />
            ))
          }
        </div>
        <h3 className="br-broadcast-message__subject">{message.subject}</h3>
        <div className="br-broadcast-message__meta">
          <strong>{message.from?.displayName}</strong>
          <time dateTime={message.sentAt}>{moment(message.sentAt).format('ll')}</time>
        </div>
        <div dangerouslySetInnerHTML={{__html: sanitizeHtml(message.html)}} />
      </article>
    );
  }
}
export default withTranslation()(withRouter((BroadcastMessageList)));
